// extracted by mini-css-extract-plugin
module.exports = {"main":"MainContent_main__16c0X","inner":"MainContent_inner__2f3em"};